import { Directive, HostListener, Input } from "@angular/core";

@Directive({ selector: "[allowedRegExp]" })
export class AllowedRegExpDirective {
  @Input() allowedRegExp: string;

  @HostListener("keydown", ["$event"]) onKeyDown(event: any): void {
    // Case: selected text (by mouse) - replace it
    const s = event.target.selectionStart;
    const e = event.target.selectionEnd;
    let k = event.target.value + event.key;

    if (s !== e) {
      k = event.target.value;
      k = k.slice(0, s) + event.key + k.slice(e, k.length);
    }

    // Case: special characters (ignore)
    if (
      [
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArroDown",
        "Backspace",
        "Tab",
        "Alt",
        "Shift",
        "Control",
        "Enter",
        "Delete",
        "Meta",
      ].includes(event.key)
    ) {
      return;
    }

    // Case: normal
    const regex = new RegExp(this.allowedRegExp);

    if (!regex.test(k)) {
      event.preventDefault();
    }
  }
}
